import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgentSessionsIncludeOnMainQueryRelayProvider = {
	get(): boolean {
		return fg('jira-ai-read-agent-sessions') && !fg('jira_agent_sessions_connected_to_read');
	},
};

export default JiraAiAgentSessionsIncludeOnMainQueryRelayProvider;
